export const data = [
  {
    "Enunciado da questão": "",
    "Objeto relacionado": "Item A",
    "00:00:00 (tempo)": "Descrição do Item A",
    "Questão aberta y / fechada n": "Item correto y / errado n",
  },
  {
    "Enunciado da questão": "",
    "Objeto relacionado": "Item B",
    "00:00:00 (tempo)": "Descrição do Item B",
    "Questão aberta y / fechada n": "Item correto y / errado n",
  },
  {
    "Enunciado da questão": "",
    "Objeto relacionado": "Item C",
    "00:00:00 (tempo)": "Descrição do Item C",
    "Questão aberta y / fechada n": "Item correto y / errado n",
  },
  {
    "Enunciado da questão": "",
    "Objeto relacionado": "Item D",
    "00:00:00 (tempo)": "Descrição do Item D",
    "Questão aberta y / fechada n": "Item correto y / errado n",
  },
];
